module.exports = __webpack_public_path__ + "ui-static/img/hooks-filter-default_light.e25f8b18.svg";